export default "__VITE_ASSET__DiWCFeq9__"